import React from "react";
import { TspFormField } from "../../../components/primitives";
import TspLeaderField from "../../../components/common/TspLeaderField";
import { LEADER_NAME_MAX } from "../journeyForm";

// The journey's Team Leader (optional), shown at the top of the Add Journey
// Place card: an ICC user picked from the suggestions, or a name typed by hand.
export default function JourneyLeaderField({ value, error, onChange, disabled }) {
  return (
    <TspFormField id="tsp-journey-leader" label="Team Leader" error={error} hint="Optional — pick a registered devotee from the list, or type the leader's name" className="tsp-jb-leader">
      <TspLeaderField
        id="tsp-journey-leader"
        value={value}
        onChange={onChange}
        disabled={disabled}
        invalid={Boolean(error)}
        describedBy={error ? "tsp-journey-leader-error" : "tsp-journey-leader-hint"}
        maxLength={LEADER_NAME_MAX + 20}
      />
    </TspFormField>
  );
}
